<template>

    <Toast/>

    <MenuFinancialCompact v-if="userStore.user?.roles?.includes('ROLE_ISORISE')" />
    <MenuHealthCompact v-else />

    <div class="px-6 surface-overlay relative">
        <div class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <ul class="list-none py-2 px-0 m-0 flex align-items-center font-medium overflow-x-auto w-full">
                        <li class="pr-3"><a class="cursor-pointer">Account</a></li>
                        <li class="px-2"><i class="pi pi-angle-right text-900"></i></li>
                        <li class="px-2"><a class="cursor-pointer text-900 white-space-nowrap">Privacy Policy</a></li>
                    </ul>

                    <h3>Privacy Policy</h3>

                    <p>
                        By using this application and our websites, you signify your acceptance of this Privacy Policy.
                        If you do not agree, please exit this application and/or websites.
                        <br><br>
                        Your continued use of the application and/or websites following the posting of changes to this
                        Policy
                        will
                        mean
                        that you accept those changes.
                    </p>
                    <Accordion>
                        <AccordionTab header="Introduction">
                            <p>
                                Protecting users’ privacy is of utmost importance to us. Accordingly, we have developed
                                this
                                Privacy
                                Policy to safeguard users’
                                personal information, and to protect your confidential personal information. This
                                privacy
                                policy
                                applies
                                to all the
                                web pages related to this application and/or our websites. Unless the context clearly
                                indicates
                                to
                                the
                                contrary,
                                any term in this Privacy Policy will bear the same meaning as defined in any of our
                                Terms and
                                Conditions,
                                Terms of Registration, or Conditions of Use, as applicable and appearing on our
                                websites.
                            </p>
                        </AccordionTab>
                        <AccordionTab header="Personal Information">
                            <p>
                                For purpose of this Privacy Policy, “personal information” means the user’s name,
                                identifying
                                number/s
                                (eg. social security number, identity number, passport number, registration number),
                                billing
                                and
                                shipping details,
                                physical and postal addresses, e-mail addresses, telephone number/s, financial details,
                                profiling
                                information,
                                and any other personal or sensitive information disclosed to us or acquired by us
                                through this
                                website.
                                <br><br>
                                We may also collect certain information following your visit to this website, such as:
                                <br>
                                the name of
                                the
                                Internet service provider and the Internet Protocol (IP) address through which you
                                access the
                                Internet;
                                <br>
                                the date and time that you access the site; the pages that you access while on the site;
                                the
                                Internet
                                address
                                of the website from which you link directly to this site; your location information;
                                information
                                specific to
                                the device you use to access this website. We may also store information when you
                                interact
                                with
                                adverts
                                on our site.
                                <br><br>
                                Personal information gathered by us, including through our online contact us, subscribe
                                and
                                order
                                forms,
                                and comment boxes may be used to personally identify users that subscribe to our service
                                or
                                purchase
                                from this website.
                                <br><br>
                                We will not ask you to disclose personal information relating to your religious or
                                philosophical
                                beliefs,
                                race or ethnic origin, trade union membership, political persuasion, health or sex life
                                except
                                where
                                such
                                information is relevant and necessarily required for us to deliver our services, or
                                otherwise
                                required
                                by law.
                                <br><br>
                                We may use personal information to help improve this website and our service offerings,
                                analyse
                                trends,
                                and administer this website. We may also use your email address, telephone number and
                                other
                                contact
                                details
                                to inform you about our products and services, let you know about changes and
                                improvements to
                                this
                                website,
                                and generally communicate with you. Personal information will not be used for any
                                purpose
                                other
                                than
                                that
                                which is stated in this Policy or in any Terms & Conditions of using our service, Terms
                                of
                                Sale,
                                Terms of Registration or Conditions of Use. By registering, accepting our terms or
                                conditions,
                                purchasing products and services, or submitting any personal information, and by
                                browsing and
                                interacting on this website, you consent to the collection and use of your personal
                                information,
                                subject to the limitations set out in this Privacy Policy. Personal information may be
                                collected
                                when a user registers on this website, submits an application form, subscribes, requests
                                a
                                quote,
                                submits a message via our “Contact Us” facility, places an order, responds to a survey,
                                or in
                                any
                                other
                                manner or form submits personal information via this site. Personal information may also
                                be
                                collected
                                through this website for the purpose of improving our service offering and increasing
                                service
                                efficiency.
                                <br><br>
                                Personal information may be collected, processed and retained on servers located outside
                                of
                                the
                                country
                                in which you live. We will use our best endeavours to keep the personal information
                                collected
                                through
                                this website as accurate, complete and up to date as is necessary for the purposes
                                mentioned
                                herein.
                                <br><br>
                                We may, from time to time, request you to update your personal information on the
                                website. On
                                request,
                                you are able to review or update any personally identifiable information belonging to
                                you that
                                we
                                have
                                recorded and retained. In order to better protect and safeguard personal information,
                                you may
                                be
                                required
                                to verify your identity before being granted access to any personal information or being
                                permitted
                                to
                                make
                                any corrections to the information. This website may use encryption, firewalls and other
                                security
                                technology
                                and procedures to help protect the confidentiality of personal information and prevent
                                unauthorised
                                access
                                or improper use thereof. All personal information is stored in the website’s database,
                                and
                                secured
                                in
                                accordance with industry standards. Notwithstanding, we do not guarantee the protection
                                of
                                personal
                                information
                                from hacking, theft or unauthorised access, and we will not be responsible for any
                                damages
                                that
                                may
                                be
                                suffered as a result of hacking, theft or unauthorised access. In the unlikely event
                                that your
                                personal
                                information is compromised, including through hacking, theft or unauthorised access, we
                                will
                                notify
                                you
                                so
                                that you can take any precautionary measures that you feel may be required. Personal
                                information
                                will be
                                retained for as long as it is necessary to fulfill the purposes mentioned herein. We may
                                also
                                be
                                required
                                by law to retain personal information for prescribed periods of time or in prescribed
                                formats.
                                We
                                will
                                delete your personal information from our records upon your request. Deletion of
                                personal
                                information,
                                whether at our instance or at your request, is not necessarily absolute, despite our
                                best
                                endeavours,
                                as there may be residual copies of the information in our back-up systems that we cannot
                                delete
                                as
                                this
                                could affect the security and integrity of our systems.
                            </p>
                        </AccordionTab>
                        <AccordionTab header="Disclosure">
                            <p>
                                We may disclose personal information to other persons for certain specified purposes,
                                including
                                for
                                credit
                                information sharing, debtor tracing, marketing and contract administration.

                                <br><br>
                                We will also provide
                                personal information to law enforcement and other competent authorities in response to
                                lawful
                                requests and including where we believe that the disclosure of the information is
                                necessary:
                                <br>
                                for any criminal or civil legal investigation; to detect or prevent fraud or other
                                criminal
                                activities;
                                <br>
                                to protect any person or the general public from harm or suffering loss or damages.
                                <br><br>
                                Where we use
                                domain administrators and outsourced IT suppliers, these administrators and suppliers
                                may need
                                to
                                or may be able to access personal information in order to perform their services
                                optimally. We
                                may
                                also appoint consultants to help us collect, interpret and use personal information in
                                line
                                with
                                this
                                Policy.
                                <br><br>
                                Any third party administrators and suppliers appointed by us will be required to adhere
                                to
                                this
                                Policy.
                                <br><br>
                                We may from time to time share non-personally identifiable information, such as
                                aggregated
                                information,
                                statistics and trends, with other companies, organisations and persons, including our
                                publishers,
                                marketers and social media consultants. If ownership of this website is transferred to
                                someone
                                else,
                                all personal information in our possession may be transferred to the new owner. If we
                                disclose
                                personal
                                information to third parties, we will limit the disclosure to the information
                                necessarily
                                required
                                by
                                the
                                third party to fulfill the purpose for the disclosure. Other than in accordance with
                                this
                                Policy
                                or
                                necessary to deliver goods or services, we will not sell, share, or rent personal
                                information
                                to
                                any
                                companies, organisations or persons outside of our group structure without obtaining
                                your
                                consent,
                                and
                                any information that is disclosed will be on a need-to-know basis. We will ask you for
                                consent
                                before we
                                use your personal information for any purpose not set out in this Policy.
                            </p>
                        </AccordionTab>
                        <AccordionTab header="Cookies">
                            <p>
                                We may from time to time make use of cookie technology, which comprises a small text
                                file that
                                is
                                stored on your computer’s hard drive containing information about you, so that the next
                                time
                                you
                                visit the website, the cookie is able to identify who you are. This enables us to
                                achieve our
                                goal
                                of
                                providing a valuable online experience to our users. You are, however, able to disable
                                this
                                cookie
                                technology
                                in your internet browser. Should you decide to do this, be aware that disabling cookies
                                may
                                result
                                in
                                services on this website not functioning correctly, optimally or as you would like.
                            </p>
                        </AccordionTab>
                        <AccordionTab header="Liability">
                            <p>
                                While we will do all things reasonably necessary to protect our users’ rights of privacy
                                whilst
                                on
                                the
                                website,
                                we cannot be held liable for any unauthorised or unlawful access to, or use, corruption
                                or
                                disclosure of
                                any personal and confidential information.
                            </p>
                        </AccordionTab>
                        <AccordionTab header="Changes to the Privacy Policy">
                            <p>
                                We may need to change this policy from time to time to address new issues and reflect
                                changes
                                on
                                our
                                site.
                                <br><br>
                                We will post those changes here so that you will always know what information we gather,
                                how
                                we
                                might
                                use
                                that information, and whether we will disclose that information to anyone. Please refer
                                back
                                to
                                this
                                policy regularly.
                            </p>
                        </AccordionTab>
                        <AccordionTab header="Credit Card Acquiring and Security">
                            <p>
                                Where credit card transactions are processed, we have implemented prudent security
                                policies
                                and
                                procedures.
                                <br><br>
                                No credit card details are stored on our website unless otherwise expressly advised, and
                                in
                                all
                                instances customer details are stored separately from credit card details. All
                                encryption
                                complies
                                with international standards. Encryption is used to protect the transmission of personal
                                information
                                when completing online transactions. Credit card transactions are processed by SagePay,
                                Payfast
                                and
                                Stripe,
                                being approved payment gateways. You may visit their websites www.sagepay.co.za,
                                www.payfast.co.za
                                and
                                www.stripe.com,
                                to view their security certificate and security policy. We only process refunds to the
                                credit
                                card
                                used
                                at the time of purchase. Please allow 30 days for the refund to appear on your credit
                                card
                                statement.
                                <br><br>
                                Any refunds granted are subject to our terms of purchase.
                            </p>
                        </AccordionTab>
                        <AccordionTab header="Complaint and Dispute Procedure">
                            <p>
                                In the event of any complaints or disputes, please email us at info@kitrin.com with the
                                full
                                details
                                of your complaint or dispute. We may require you to provide additional information and
                                details
                                before we
                                are able to resolve the complaint or dispute. We endeavour to resolve complaints and
                                disputes
                                within
                                60 days after our receipt of all the relevant information.
                            </p>
                        </AccordionTab>
                        <AccordionTab header="Corporate Details">
                            <p>
                                Registered name: KITRIN (UK) LIMITED
                                <br>
                                Registration number: 2014/203647/07
                                <br>
                                Place of registration: United Kingdom
                                <br>
                                Our directors are: Oliver Nagaya, Ingrid Dian Nagaya, Stephen RP Hodge
                                <br>
                                Our owners are: Oliver Nagaya and Ingrid Dian Nagaya
                                <br><br>
                                We choose the following address as our place of domicilium for all purposes related to
                                this
                                website,
                                including in relation to any products, services or information supplied via this website
                                under
                                this
                                agreement,
                                and whether in respect of court process, notice, or other documents or communication of
                                whatever
                                nature.
                                <br><br>
                                Domicilium address: Bank House, 81 St Judes Road, Englefield Green, Surrey, United Kingdom, TW20 0DF
                                <br><br>
                                If you have any questions or concerns about our privacy policy, please contact us on:
                                Email address: info@kitrin.com
                                Telephone numbers: +44 (0)1784 614 787 (UK), +27 (0)10 500 3200 (SA)
                                <br><br>
                                By using this application and/or our websites, you consent to the collection, processing
                                and
                                disclosure
                                of personal information
                                in accordance with this Policy. If you wish to withdraw your consent to this Policy at
                                any
                                time
                                in
                                the
                                future,
                                you may do so by requesting us, in writing, to archive or delete your personal
                                information in
                                our
                                records.
                                Deletion of your personal information may, however, be subject to any applicable
                                requirements
                                placed
                                on
                                us by law to retain the personal information.
                            </p>
                        </AccordionTab>
                    </Accordion>

                </div>
            </div>
        </div>
    </div>

    <IsoEvolveFooter/>

</template>

<script>
import IsoEvolveFooter from "@/components/heading/authentication/IsoEvolveFooter.vue";
import MenuHealthCompact from "@/components/menu/health/MenuHealthCompact.vue";
import {useUserStore} from "@/stores/UserStore";
import UserService from "@/service/UserService";
import MenuFinancialCompact from "@/components/menu/famodule/MenuFinancialCompact.vue";

export default {
    components: {
        MenuFinancialCompact,
        IsoEvolveFooter, MenuHealthCompact
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    async mounted() {
        await this.loadCompanyContext();
    },
    data() {

        return {
            profile: {},
        }
    },
    watch: {
        'userStore.activeCompanyId': {
            immediate: false,
            async handler(newCompanyId, oldCompanyId) {
                if (!newCompanyId || newCompanyId === oldCompanyId) {
                    return;
                }

                console.log(
                    '[Appointments][watch] Company changed:',
                    oldCompanyId,
                    '→',
                    newCompanyId
                );

                await this.loadCompanyContext();
            }
        }
    },
    methods: {
        async loadCompanyContext() {
            try {
                // Attempt to get user data
                const userData = await UserService.getUser(this.userStore.user.id);
                this.profile = userData.data;
            } catch (e) {
                console.error("[AppointmentsNew][mounted] Error fetching user data = ", e);
                this.userStore.clearUser();
                this.$router.push('login');
                return;
            }

            this.profile.companyId = this.userStore.activeCompanyId;
        },
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
